<template>
  <v-container fluid>

    <!-- 참가자 정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_user" @keydown.esc="dialog_user = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_userinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_user = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="visitorItem.IDX" :label="$t('eul_col2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.COM_NAME" :label="$t('eventinvit_label15')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.EVENT_NAME" :label="$t('eventinvit_label16')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? visitorItem.OPTION_NAME : visitorItem.OPTION_NAME_ENG" :label="$t('eventinvit_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="visitorItem.REGTYPE_NAME" :label="$t('common_userinfo_label18')" disabled></v-text-field>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->              
              <template v-for="item in infoItem">
                <template v-if="item.USETYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="visitorItem['INFO'+item.INPUT_CODE]" class="image"/>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label5')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else-if="item.LANTYPE == 5">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <a :href="visitorItem['INFO'+item.INPUT_CODE]" download target="_blink">File Download</a>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label19')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="item.MAXLINES == 1">
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-textarea dense no-resize outlined height="70"
                        v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-textarea>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-text-field v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-text-field>
                      </v-row>
                    </template>
                  </template>
                </template>
              </template>

              <v-row dense v-if="useInfo.USETEL == 1">
                  <v-text-field v-model="visitorItem.TEL" :label="$t('common_userinfo_label6')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEMAIL == 1">
                  <v-text-field v-model="visitorItem.EMAIL" :label="$t('common_userinfo_label7')" disabled></v-text-field>
              </v-row>

              <v-row dense v-if="useInfo.USEPW == 1">
                  <v-text-field v-model="visitorItem.PRINT_NUMBER" :label="$t('common_userinfo_label8')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USESEX == 1">
                  <v-text-field v-model="visitorItem.SEX_NAME" :label="$t('common_userinfo_label9')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEYEAR == 1">
                  <v-text-field v-model="visitorItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USENATION == 1">
                  <v-text-field v-model="visitorItem.NAMEKOR" :label="$t('common_userinfo_label12')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_user = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    

    <v-row align="center" dense no-gutters>
      <v-col cols="3">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col  cols="12" offset-md="1" md="3" sm="12" xs="12">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
    </v-row>

    <v-row align="center" dense>
      <v-col cols="6" md="1">
        <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
    </v-col>
      <v-spacer/>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale" @change="search_run"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" align="center" class="pa-0">
        <v-btn style="width:94%" color="#4e6ef7" large rounded  @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
      
    </v-row>


  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        height="600px"
        fixed-header
        >
        <template v-slot:header.VISITOR_IDX>
          <a :class="sort_name=='VISITOR_IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('VISITOR_IDX')">{{$t('vdpoint_col1')}}</a>
        </template>
        <template v-slot:header.NAME>
          <a :class="sort_name=='NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAME')">{{$t('vdpoint_col2')}}</a>
        </template>
        <template v-slot:header.OPTION_NAME>
          <a :class="sort_name=='OPTION_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('OPTION_NAME')">{{$t('vdpoint_col3')}}</a>
        </template>
        <template v-slot:header.STATE_NAME>
          <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t('vdpoint_col4')}}</a>
        </template>
        <template v-slot:header.USER_TYPENAME>
          <a :class="sort_name=='USER_TYPENAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('USER_TYPENAME')">{{$t('vdpoint_col5')}}</a>
        </template>
        <template v-slot:header.TEL>
          <a :class="sort_name=='TEL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TEL')">{{$t('vdpoint_col6')}}</a>
        </template>

        <template v-slot:header.DAY1_INTIME>
          <a :class="sort_name=='DAY1_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY1_INTIME')">{{$t('vdpoint_col7')}}</a>
        </template>
        <template v-slot:header.DAY1_OUTTIME>
          <a :class="sort_name=='DAY1_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY1_OUTTIME')">{{$t('vdpoint_col8')}}</a>
        </template>
        <template v-slot:header.DAY1_SHOWMIN>
          <a :class="sort_name=='DAY1_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY1_SHOWMIN')">{{$t('vdpoint_col9')}}</a>
        </template>
        <template v-slot:header.DAY1_POINT>
          <a :class="sort_name=='DAY1_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY1_POINT')">{{$t('vdpoint_col10')}}</a>
        </template>
        <template v-slot:header.DAY2_INTIME>
          <a :class="sort_name=='DAY2_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY2_INTIME')">{{$t('vdpoint_col11')}}</a>
        </template>
        <template v-slot:header.DAY2_OUTTIME>
          <a :class="sort_name=='DAY2_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY2_OUTTIME')">{{$t('vdpoint_col12')}}</a>
        </template>
        <template v-slot:header.DAY2_SHOWMIN>
          <a :class="sort_name=='DAY2_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY2_SHOWMIN')">{{$t('vdpoint_col13')}}</a>
        </template>
        <template v-slot:header.DAY2_POINT>
          <a :class="sort_name=='DAY2_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY2_POINT')">{{$t('vdpoint_col14')}}</a>
        </template>
        <template v-slot:header.DAY3_INTIME>
          <a :class="sort_name=='DAY3_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY3_INTIME')">{{$t('vdpoint_col15')}}</a>
        </template>
        <template v-slot:header.DAY3_OUTTIME>
          <a :class="sort_name=='DAY3_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY3_OUTTIME')">{{$t('vdpoint_col16')}}</a>
        </template>
        <template v-slot:header.DAY3_SHOWMIN>
          <a :class="sort_name=='DAY3_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY3_SHOWMIN')">{{$t('vdpoint_col17')}}</a>
        </template>
        <template v-slot:header.DAY3_POINT>
          <a :class="sort_name=='DAY3_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY3_POINT')">{{$t('vdpoint_col18')}}</a>
        </template>
        <template v-slot:header.DAY4_INTIME>
          <a :class="sort_name=='DAY4_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY4_INTIME')">{{$t('vdpoint_col19')}}</a>
        </template>
        <template v-slot:header.DAY4_OUTTIME>
          <a :class="sort_name=='DAY4_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY4_OUTTIME')">{{$t('vdpoint_col20')}}</a>
        </template>
        <template v-slot:header.DAY4_SHOWMIN>
          <a :class="sort_name=='DAY4_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY4_SHOWMIN')">{{$t('vdpoint_col21')}}</a>
        </template>
        <template v-slot:header.DAY4_POINT>
          <a :class="sort_name=='DAY4_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY4_POINT')">{{$t('vdpoint_col22')}}</a>
        </template>
        <template v-slot:header.DAY5_INTIME>
          <a :class="sort_name=='DAY5_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY5_INTIME')">{{$t('vdpoint_col23')}}</a>
        </template>
        <template v-slot:header.DAY5_OUTTIME>
          <a :class="sort_name=='DAY5_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY5_OUTTIME')">{{$t('vdpoint_col24')}}</a>
        </template>
        <template v-slot:header.DAY5_SHOWMIN>
          <a :class="sort_name=='DAY5_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY5_SHOWMIN')">{{$t('vdpoint_col25')}}</a>
        </template>
        <template v-slot:header.DAY5_POINT>
          <a :class="sort_name=='DAY5_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY5_POINT')">{{$t('vdpoint_col26')}}</a>
        </template>
        <template v-slot:header.DAY6_INTIME>
          <a :class="sort_name=='DAY6_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY6_INTIME')">{{$t('vdpoint_col27')}}</a>
        </template>
        <template v-slot:header.DAY6_OUTTIME>
          <a :class="sort_name=='DAY6_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY6_OUTTIME')">{{$t('vdpoint_col28')}}</a>
        </template>
        <template v-slot:header.DAY6_SHOWMIN>
          <a :class="sort_name=='DAY6_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY6_SHOWMIN')">{{$t('vdpoint_col29')}}</a>
        </template>
        <template v-slot:header.DAY6_POINT>
          <a :class="sort_name=='DAY6_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY6_POINT')">{{$t('vdpoint_col30')}}</a>
        </template>
        <template v-slot:header.DAY7_INTIME>
          <a :class="sort_name=='DAY7_INTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY7_INTIME')">{{$t('vdpoint_col31')}}</a>
        </template>
        <template v-slot:header.DAY7_OUTTIME>
          <a :class="sort_name=='DAY7_OUTTIME'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY7_OUTTIME')">{{$t('vdpoint_col32')}}</a>
        </template>
        <template v-slot:header.DAY7_SHOWMIN>
          <a :class="sort_name=='DAY7_SHOWMIN'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY7_SHOWMIN')">{{$t('vdpoint_col33')}}</a>
        </template>
        <template v-slot:header.DAY7_POINT>
          <a :class="sort_name=='DAY7_POINT'?'cheader_sortselect':'cheader_sort'" @click="customsortday('DAY7_POINT')">{{$t('vdpoint_col34')}}</a>
        </template>



        <template v-slot:item.DAY1_POINT="{ item }">
          <div>{{ item.DAY1_POINT }}</div>
          <div v-if="item.DAY1_ESSEN_POINT != null">{{ "("+(item.DAY1_POINT-item.DAY1_ESSEN_POINT)+"/"+item.DAY1_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY2_POINT="{ item }">
          <div>{{ item.DAY2_POINT }}</div>
          <div v-if="item.DAY2_ESSEN_POINT != null">{{ "("+(item.DAY2_POINT-item.DAY2_ESSEN_POINT)+"/"+item.DAY2_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY3_POINT="{ item }">
          <div>{{ item.DAY3_POINT }}</div>
          <div v-if="item.DAY3_ESSEN_POINT != null">{{ "("+(item.DAY3_POINT-item.DAY3_ESSEN_POINT)+"/"+item.DAY3_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY4_POINT="{ item }">
          <div>{{ item.DAY4_POINT }}</div>
          <div v-if="item.DAY4_ESSEN_POINT != null">{{ "("+(item.DAY4_POINT-item.DAY4_ESSEN_POINT)+"/"+item.DAY4_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY5_POINT="{ item }">
          <div>{{ item.DAY5_POINT }}</div>
          <div v-if="item.DAY5_ESSEN_POINT != null">{{ "("+(item.DAY5_POINT-item.DAY5_ESSEN_POINT)+"/"+item.DAY5_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY6_POINT="{ item }">
          <div>{{ item.DAY6_POINT }}</div>
          <div v-if="item.DAY6_ESSEN_POINT != null">{{ "("+(item.DAY6_POINT-item.DAY6_ESSEN_POINT)+"/"+item.DAY6_ESSEN_POINT+")"}}</div>
        </template>
        <template v-slot:item.DAY7_POINT="{ item }">
          <div>{{ item.DAY7_POINT }}</div>
          <div v-if="item.DAY7_ESSEN_POINT != null">{{ "("+(item.DAY7_POINT-item.DAY7_ESSEN_POINT)+"/"+item.DAY7_ESSEN_POINT+")"}}</div>
        </template>

        <template v-slot:item.NAME="{ item }">
          <a @click="loadvisitor(item.VISITOR_IDX, item.EVENT_IDX)" >{{item.NAME}}</a>
        </template>

        <template v-slot:item.OPTION_NAME="{ item }">
          <label>{{ $i18n.locale === 'ko' ? item.OPTION_NAME : item.OPTION_NAME_ENG }}</label>
        </template>

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  </v-container>
</template>
<script>

import moment from 'moment'
import XLSX from 'xlsx'

export default {

  beforeDestroy(){

  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    /*
    if(this.grade > 90){
      this.headers.push({text: '삭제', value: 'delete', sortable: false, align:'center' });
    }
    */
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(6, 'DAY').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date = moment().subtract(6, 'DAY').format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({
    useInfo:{},
    //필수 페이징 파라메터
    totalcnt : 0,       //전체 아이템 개수
    page : 0,
    maxpage : 0,        //전체 페이지 개수
    startpage : 1,      //시작 인덱스
    bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
    subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
    loading : false,    //로딩 표시

    //테이블 정의
    headers: [
      {text: '등록번호', value: 'VISITOR_IDX', width:"150", sortable: false, align:'center'},
      {text: '이름', value: 'NAME', width:"150", sortable: false, align:'center'},
      {text: '등록 카테고리', value: 'OPTION_NAME', width:"150", sortable: false, align:'center'},
      {text: '상태', value: 'STATE_NAME', width:"100", sortable: false, align:'center'},
      {text: '회원', value: 'USER_TYPENAME', width:"100", sortable: false, align:'center'},
      {text: '전화번호', value: 'TEL', width:"150", sortable: false, align:'center' },
      {text: '1일차 입장', value: 'DAY1_INTIME', width:"160", sortable: false, align:'center' },
      {text: '1일차 퇴장', value: 'DAY1_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '1일차 체류', value: 'DAY1_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '1일차 평점', value: 'DAY1_POINT', width:"120",sortable: false, align:'center' },
      {text: '2일차 입장', value: 'DAY2_INTIME', width:"160",sortable: false, align:'center' },
      {text: '2일차 퇴장', value: 'DAY2_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '2일차 체류', value: 'DAY2_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '2일차 평점', value: 'DAY2_POINT', width:"120",sortable: false, align:'center' },
      {text: '3일차 입장', value: 'DAY3_INTIME', width:"160",sortable: false, align:'center' },
      {text: '3일차 퇴장', value: 'DAY3_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '3일차 체류', value: 'DAY3_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '3일차 평점', value: 'DAY3_POINT', width:"120",sortable: false, align:'center' },
      {text: '4일차 입장', value: 'DAY4_INTIME', width:"160",sortable: false, align:'center' },
      {text: '4일차 퇴장', value: 'DAY4_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '4일차 체류', value: 'DAY4_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '4일차 평점', value: 'DAY4_POINT', width:"120",sortable: false, align:'center' },
      {text: '5일차 입장', value: 'DAY5_INTIME', width:"160",sortable: false, align:'center' },
      {text: '5일차 퇴장', value: 'DAY5_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '5일차 체류', value: 'DAY5_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '5일차 평점', value: 'DAY5_POINT', width:"120",sortable: false, align:'center' },
      {text: '6일차 입장', value: 'DAY6_INTIME', width:"160",sortable: false, align:'center' },
      {text: '6일차 퇴장', value: 'DAY6_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '6일차 체류', value: 'DAY6_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '6일차 평점', value: 'DAY6_POINT', width:"120",sortable: false, align:'center' },
      {text: '7일차 입장', value: 'DAY7_INTIME', width:"160",sortable: false, align:'center' },
      {text: '7일차 퇴장', value: 'DAY7_OUTTIME', width:"160",sortable: false, align:'center' },
      {text: '7일차 체류', value: 'DAY7_SHOWMIN', width:"120",sortable: false, align:'center' },
      {text: '7일차 평점', value: 'DAY7_POINT', width:"120",sortable: false, align:'center' },
    ],
    itemList: [],

    sort_name: 'DAY1_INTIME',
    sort_type: true,    //true : DESC, false: ASC

    search_keyword : '',
    search: '',         //필터링용 검색어

    //한 페이지 ROW 개수 설정
    pagerow : 20,       //한 페이지에 보여줄 row수
    pagerow_combo : [
        {NAME:'20', VALUE:20}
      , {NAME:'50', VALUE:50}
      , {NAME:'100', VALUE:100}
      , {NAME:'200', VALUE:200}
    ],    


    date1:false,
    date2:false,
    search_start_date : '',
    search_end_date : '',
    
    list:[],

    SEARCH_COM_IDX: null,
    SEARCH_COM_NAME: '',
    SEARCH_EVENT_IDX: null,
    SEARCH_EVENT_NAME: '',
    grade : 0,

    dialog_user:false,    
    visitorItem: {},
    infoItem:[],    //행사별 기본접수양식 커스텀 정보 

  }),

  methods: {


    insertAt(array, index, item) {
      array.splice(index, 0, item);
    },

    startDownload(){

        this.$confirm(this.$t('common_search_downexcel')).then(() => {

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }
          if(this.search_start_date.length < 4){
            this.$alert(this.$t('common_search_start_info1'));
            return;
          }

          
          this.search_end_date = moment(this.search_start_date).add(6, 'days').format("YYYY-MM-DD");
          /*
          if(this.search_end_date.length < 4){
            this.$alert(this.$t('common_search_end_info1'));
            return;
          }
          if(this.search_start_date > this.search_end_date){
            this.$alert(this.$t('common_search_date_error1'));
            return;
          }
          */       
          
          
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorDayPointExcel',{
              search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
            , sort_name:this.sort_name
            , sort_type: this.sort_type==true ? "DESC" : "ASC" 
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: this.SEARCH_EVENT_IDX
            , COM_IDX: this.SEARCH_COM_IDX
            , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
            , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
            , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                var item_sheet = XLSX.utils.json_to_sheet(list);
                
                //컬럼명 수정
                item_sheet.A1 = {v:this.$t('vdpoint_excel1')};
                item_sheet.B1 = {v:this.$t('vdpoint_excel2')};
                item_sheet.C1 = {v:this.$t('vdpoint_excel3')};
                item_sheet.D1 = {v:this.$t('vdpoint_excel4')};
                item_sheet.E1 = {v:this.$t('vdpoint_excel5')};
                item_sheet.F1 = {v:this.$t('vdpoint_excel6')};
                item_sheet.G1 = {v:this.$t('vdpoint_excel7')};
                item_sheet.H1 = {v:this.$t('vdpoint_excel8')};
                item_sheet.I1 = {v:this.$t('vdpoint_excel9')};
                item_sheet.J1 = {v:this.$t('vdpoint_excel10')};
                item_sheet.K1 = {v:this.$t('vdpoint_excel11')};
                item_sheet.L1 = {v:this.$t('vdpoint_excel12')};
                item_sheet.M1 = {v:this.$t('vdpoint_excel13')};
                item_sheet.N1 = {v:this.$t('vdpoint_excel14')};
                item_sheet.O1 = {v:this.$t('vdpoint_excel15')};
                item_sheet.P1 = {v:this.$t('vdpoint_excel16')};
                item_sheet.Q1 = {v:this.$t('vdpoint_excel17')};
                item_sheet.R1 = {v:this.$t('vdpoint_excel18')};
                item_sheet.S1 = {v:this.$t('vdpoint_excel19')};
                item_sheet.T1 = {v:this.$t('vdpoint_excel20')};
                item_sheet.U1 = {v:this.$t('vdpoint_excel21')};
                item_sheet.V1 = {v:this.$t('vdpoint_excel22')};
                item_sheet.W1 = {v:this.$t('vdpoint_excel23')};
                item_sheet.X1 = {v:this.$t('vdpoint_excel24')};
                item_sheet.Y1 = {v:this.$t('vdpoint_excel25')};
                item_sheet.Z1 = {v:this.$t('vdpoint_excel26')};
                item_sheet.AA1 = {v:this.$t('vdpoint_col7')};
                item_sheet.AB1 = {v:this.$t('vdpoint_col8')};
                item_sheet.AC1 = {v:this.$t('vdpoint_col9')};
                item_sheet.AD1 = {v:this.$t('vdpoint_col10')};
                item_sheet.AE1 = {v:this.$t('vdpoint_excel27')};
                item_sheet.AF1 = {v:this.$t('vdpoint_col11')};
                item_sheet.AG1 = {v:this.$t('vdpoint_col12')};
                item_sheet.AH1 = {v:this.$t('vdpoint_col13')};
                item_sheet.AI1 = {v:this.$t('vdpoint_col14')};
                item_sheet.AJ1 = {v:this.$t('vdpoint_excel28')};
                item_sheet.AK1 = {v:this.$t('vdpoint_col15')};
                item_sheet.AL1 = {v:this.$t('vdpoint_col16')};
                item_sheet.AM1 = {v:this.$t('vdpoint_col17')};
                item_sheet.AN1 = {v:this.$t('vdpoint_col18')};
                item_sheet.AO1 = {v:this.$t('vdpoint_excel29')};
                item_sheet.AP1 = {v:this.$t('vdpoint_col19')};
                item_sheet.AQ1 = {v:this.$t('vdpoint_col20')};
                item_sheet.AR1 = {v:this.$t('vdpoint_col21')};
                item_sheet.AS1 = {v:this.$t('vdpoint_col22')};
                item_sheet.AT1 = {v:this.$t('vdpoint_excel30')};
                item_sheet.AU1 = {v:this.$t('vdpoint_col23')};
                item_sheet.AV1 = {v:this.$t('vdpoint_col24')};
                item_sheet.AW1 = {v:this.$t('vdpoint_col25')};
                item_sheet.AX1 = {v:this.$t('vdpoint_col26')};
                item_sheet.AY1 = {v:this.$t('vdpoint_excel31')};
                item_sheet.AZ1 = {v:this.$t('vdpoint_col27')};
                item_sheet.BA1 = {v:this.$t('vdpoint_col28')};
                item_sheet.BB1 = {v:this.$t('vdpoint_col29')};
                item_sheet.BC1 = {v:this.$t('vdpoint_col30')};
                item_sheet.BD1 = {v:this.$t('vdpoint_excel32')};
                item_sheet.BE1 = {v:this.$t('vdpoint_col31')};
                item_sheet.BF1 = {v:this.$t('vdpoint_col32')};
                item_sheet.BG1 = {v:this.$t('vdpoint_col33')};
                item_sheet.BH1 = {v:this.$t('vdpoint_col34')};
                item_sheet.BI1 = {v:this.$t('vdpoint_excel33')};

                //컬럼별 너비
                var wscols = [{wch:20},{wch:30},{wch:20},{wch:10},{wch:10},{wch:10},{wch:20,},{wch:20},{wch:15},{wch:15},{wch:10},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15}];
                item_sheet['!cols'] = wscols;

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('vdpoint_msg1'));
                XLSX.writeFile(wb, this.$t('vdpoint_msg2')+moment().format('YYYYMMDDHHmmss')+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });
    },

    initpage(){
      this.getInfoItemList();
      //첫페이지 로드
      this.loadpage(1);
    },

    loadpage(p){
      if(this.SEARCH_COM_IDX == null){
        this.$alert(this.$t('common_select_tcom'));
        return;
      }
      if(this.SEARCH_EVENT_IDX == null){
        this.$alert(this.$t('common_select_tevent'));
        return;
      }
      if(this.search_start_date.length < 4){
        this.$alert(this.$t('common_search_start_info1'));
        return;
      }



      this.search_end_date = moment(this.search_start_date).add(6, 'days').format("YYYY-MM-DD");
      /*
      if(this.search_end_date.length < 4){
        this.$alert(this.$t('common_search_end_info1'));
        return;
      }
      if(this.search_start_date > this.search_end_date){
        this.$alert(this.$t('common_search_date_error1'));
        return;
      }
      */       
      
      this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      this.loading = true;
      this.page = p;

      this.$http.post(this.$host+'/api/VisitorDayPointList',{
            search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
          , sort_name:this.sort_name
          , sort_type: this.sort_type==true ? "DESC" : "ASC" 
          , page: this.page
          , pagerow: this.pagerow
          , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , COM_IDX: this.SEARCH_COM_IDX
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
          , LAN_CODE:this.$i18n.locale
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.totalcnt = result.data.totalcnt;
            this.makepaging();
            const list = result.data.resultData;
            list.forEach(element => {
                this.itemList.push(element); 
            });

            this.loading = false;

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.loading = false;
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }else{
          this.loading = false;
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },    

    search_run(){

      this.loadpage(1);

    },

    loadvisitor(vidx, eidx){

        this.$http.post(this.$host+'/api/VisitorDetail',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: eidx
            , VISITOR_IDX: vidx
            , LAN_CODE:this.$i18n.locale
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              this.visitorItem = list[0];
              this.dialog_user = true;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          
        });

    },          

    //행사별 기본접수양식 가져오기
    getInfoItemList(){
      
      this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
      
      if(this.SEARCH_COM_IDX == null){
          return;
      }
      if(this.SEARCH_EVENT_IDX == null){
        return;
      }

      this.$http.post(this.$host+'/api/InputEventList',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        if(result.data.resultCode == 0){
            
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.useInfo = result.data.useData;
            const list = result.data.resultData;
            list.forEach(element => {
                this.infoItem.push(element); 
            });
        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.loading = false;
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });
    },    

    customsort(sortname){
      this.sort_name = sortname;
      this.sort_type = !this.sort_type;
      this.loadpage(this.page);
    },

    //일차별 정렬은 널값을 뒤로 밀어야 한다.
    customsortday(sortname){
      this.sort_name = `(${sortname} IS NULL) ASC, ${sortname}`;
      this.sort_type = !this.sort_type;
      this.loadpage(this.page);
    },

    prev(){
        this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
        this.loadpage(temp_page);
    },
    next(){
        this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage;
        this.loadpage(temp_page);
    },

    makepaging(){
      var div1 = this.totalcnt / this.pagerow; 
      var div2 = this.totalcnt % this.pagerow;
      if(div2 == 0){  
          this.maxpage = parseInt(div1);    
      }else{
          this.maxpage = parseInt(div1+1);
      }
      if(this.bottompage == 1){
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
      }
    },



    //검색조건 업체 설정
    eventsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", val1.EVENT_START);
        this.$session.set("EVENT_END", val1.EVENT_END);

        //infoItem 가져오기
        this.getInfoItemList();

      }else{
        this.SEARCH_EVENT_NAME = "";
        this.SEARCH_EVENT_IDX  = null;
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);
      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>